import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect, Switch, Link, HashRouter } from "react-router-dom";
import Routes from "./components/routing/Routes";
import NavbarShow from "./components/layout/NavbarShow";
import Alert from "./components/layout/Alert";
import Login from "./components/auth/Login";
import PNChat from "./components/PubNub";
import { setCurrentUser } from "./actions/authAction";
import ErrorBoundry from "./components/ErrorBoundry";
import CreateMerchantProfile from "./components/CreateMerchantProfile";
import CreateUserProfile from "./components/CreateUserProfile";
import ContactContainer from "./containers/ContactContainer";

class App extends Component {
  render() {
    return (
      <ErrorBoundry>
        {this.props.user.isLoggedIn &&
          this.props.user.currentUser.currentUser.admin && <NavbarShow />}
        <Alert />
        {this.props.user.isLoggedIn ? (
          <Route component={Routes} />
        ) : (
          <Switch>
            <Route exact path="/pnchat" component={PNChat} />
            <Route
              exact
              path="/create-merchant"
              component={CreateMerchantProfile}
            />
            <Route exact path="/dc/:id" component={ContactContainer} />
            <Route exact path="/create-user" component={CreateUserProfile} />
            <Route path="/login" render={(props) => <Login {...props} />} />
          </Switch>
        )}
        {/* <Route
            exact
            path="/signup"
            render={() =>
              this.props.user.isLoggedIn ? (
                <Redirect to="/" />
              ) : (
                <Signup {...props} />
              )
            }
          /> */}
      </ErrorBoundry>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user: user,
});
const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
